import { Component } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { AuthenticationService } from '../Services/authentication.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
// logo :any ='../../../Assests/Logo.svg'
validateForm = this.fb.group({
  username: this.fb.control('', [Validators.required]),
  password: this.fb.control('', [Validators.required]),
  remember: this.fb.control(true)
});
  submitted: boolean = false;
  loginerror: boolean =  false;
  error: any;
  loading: boolean = false;


constructor(
  //  private formBuilder: FormBuilder,
  private route: ActivatedRoute,
  private router: Router,
  private authenticationService: AuthenticationService, private fb: NonNullableFormBuilder) {}

// submitForm(): void {
//   if (this.validateForm.valid) {
//   } else {
//     Object.values(this.validateForm.controls).forEach(control => {
//       if (control.invalid) {
//         control.markAsDirty();
//         control.updateValueAndValidity({ onlySelf: true });
//       }
//     });
//   }
// }

submitForm() {
  this.submitted = true;
  this.loginerror = false;
  // if (this.validateForm.invalid) {
  //     return;
  // }
  // this.authenticationService.login(this.f['email'].value, this.f['password'].value)
  if (this.validateForm.valid) {
  this.authenticationService.login(this.validateForm.value.username == undefined ? '' : this.validateForm.value.username, this.validateForm.value.password == undefined ? '' : this.validateForm.value.password)
      .pipe(first())
      .subscribe(
          data => {
              // this.router.navigate([this.returnUrl]);
              // if (data.status) {
              //     if(this.selectedrole === 'student'){
              //         this.router.navigate(['auth/studentview'],{ queryParams: { dataId:data.data.id} }).then(() => {
              //             window.location.href = this.router.url;
              //         });
              //     } else{
                      this.router.navigate(['/applications']
                      //   , { queryParams: { dataId:data.data.id} }).then(() => {
                      //     window.location.href = this.router.url;
                      // }
                    );
                  // }
              // } else {
              //     this.loginerror = true
              // }
          },
          error => {
              this.error = error;
              this.loading = false;
          });
        }
}

}
